function CampaignInsightModel() {
    this.id = "";
    this.name = "";
    this.agent_count = 0;
    this.duration = "";
    this.alerthits = [];
    this.questionhits = { agent: [], client: [] };
    this.topicshits = [];
    this.sentiment = [];
    this.trackerhits = [];
    this.wpm = [];
    this.speaker_analysis = [];
    this.vocalys_score = 0;
    this.total_calls = 0;
};

export {
    CampaignInsightModel
}